{
  "version": 1,
  "asset_id": "d58c732b-ded5-48d0-990b-9ff341fba402",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/d58c732b-ded5-48d0-990b-9ff341fba402/svc-content-strategy-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/d58c732b-ded5-48d0-990b-9ff341fba402/svc-content-strategy-640.avif",
  "original_filename": "svc-content-strategy-640.avif",
  "size": 6150,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:42Z"
}
